import { useApiQuery } from './useApiQuery';

interface UserAnalytics {
  totalLeads: number;
  registeredLeads: number;
  unregisteredLeads: number;
  remindersSet: number;
}

interface UserAnalyticsResponse {
  success: boolean;
  message: string;
  data: {
    analytics: UserAnalytics;
  };
}

export function useUserAnalytics() {
  return useApiQuery<UserAnalyticsResponse>({
    queryKey: ['user-analytics'],
    request: {
      method: 'GET',
      url: '/analytics/user',
    },
  });
}

export type { UserAnalytics, UserAnalyticsResponse };
